import { useEffect, useMemo, useState } from "react";

/** Client-side pagination for report grids (matches PortPlace Pagination). */
export const useClientReportPagination = (items = [], defaultPageSize = 10) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(defaultPageSize);

    const totalRecord = items?.length ?? 0;
    const totalPages = Math.max(1, Math.ceil(totalRecord / recordsPerPage) || 1);

    useEffect(() => {
        setCurrentPage(1);
    }, [items, recordsPerPage]);

    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [currentPage, totalPages]);

    const paginatedItems = useMemo(() => {
        const start = (currentPage - 1) * recordsPerPage;
        return (items || []).slice(start, start + recordsPerPage);
    }, [items, currentPage, recordsPerPage]);

    return {
        currentPage,
        recordsPerPage,
        setRecordsPerPage,
        paginatedItems,
        totalRecord,
        handlePrevious: (page) => setCurrentPage(Math.max(1, page)),
        handleNext: (page) => setCurrentPage(Math.min(totalPages, page)),
        handleGoto: (page) =>
            setCurrentPage(Math.min(totalPages, Math.max(1, Number(page) || 1))),
    };
};
